exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0d3a1e12!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/Quotes.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-0d3a1e12!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/Quotes.vue
// module chunks = 0